const menuItems = {
  items: [
    {
      id: '4',
      title: 'HR ADMIN',
      type: 'group',
      icon: 'icon-navigation',
      children: [
        {
          id: 'dashboard',
          title: 'Dashboard',
          type: 'item',
          icon: 'feather icon-home',
          classes: 'nav-item',
          url: '/app/dashboard/analytics',
          breadcrumbs: false
        },

        {
          id: 'global-settings',
          title: 'Global Settings',
          type: 'collapse',
          icon: 'feather icon-globe',
          classes: 'nav-item',
          children: [
            {
              id: 'company-settings',
              title: 'Company Settings',
              type: 'item',
              url: '/leave/employee-pay-setup',
              breadcrumbs: false
            },
            {
              id: 'general-codes',
              title: 'General Codes',
              type: 'item',
              url: '/leave/employee-pay-setup'
            },
            {
              id: 'serial-numbers',
              title: 'Serial Numbers',
              type: 'item',
              url: '/leave/employee-pay-setup'
            }
          ]
        },

        {
          id: 'menu-level',
          title: 'Employee Setup',
          type: 'collapse',
          icon: 'feather icon-users',
          classes: 'nav-item',
          children: [
            {
              id: 'employee-setup',
              title: 'Employee Pay Setup',
              type: 'item',
              url: '/leave/employee-pay-setup',
              breadcrumbs: false
            },
            {
              id: 'employee-details',
              title: 'Employee Details',
              type: 'item',
              url: '/customers/customer-list',
              breadcrumbs: false
            },
            {
              id: 'employee-leave',
              title: 'Employee Leave',
              type: 'collapse',
              children: [
                {
                  id: 'leave-entry',
                  title: 'Leave Entry',
                  type: 'item',
                  url: '/leave/leave-entry',
                  breadcrumbs: false
                },
                {
                  id: 'leave-approvals',
                  title: 'Leave Approvals',
                  type: 'item',
                  url: '/leave/leave-approval',
                  breadcrumbs: false
                },
                {
                  id: 'leave-queries',
                  title: 'Leave Queries',
                  type: 'collapse',
                  children: [
                    {
                      id: 'leave-taken',
                      title: 'Leave Taken',
                      type: 'item',
                      url: ''
                    },
                    {
                      id: 'leave-schedule',
                      title: 'Scheduled Leave',
                      type: 'item',
                      url: ''
                    }
                  ]
                },
                {
                  id: 'leave-management',
                  title: 'Leave Management',
                  type: 'item',
                  url: ''
                }
              ]
            }
          ]
        },
        {
          id: 'payroll-setup',
          title: 'Payroll Setup',
          type: 'collapse',
          icon: 'feather icon-settings',
          classes: 'nav-item',
          children: [
            {
              id: 'payroll-items',
              title: 'Define Payroll Items',
              type: 'item',
              url: '/leave/employee-pay-setup',
              breadcrumbs: false
            },
            {
              id: 'payroll-tables',
              title: 'Payroll Tables',
              type: 'item',
              url: '/leave/employee-pay-setup',
              breadcrumbs: false
            },
            {
              id: 'payroll-controls',
              title: 'Payroll Controls',
              type: 'item',
              url: '/leave/employee-pay-setup',
              breadcrumbs: false
            },
            {
              id: 'payroll-periods',
              title: 'Payroll Periods',
              type: 'item',
              url: '/leave/employee-pay-setup',
              breadcrumbs: false
            },
            {
              id: 'employee-earnings/deductions',
              title: 'Employee Earnings/Deductions',
              type: 'item',
              url: '/leave/employee-pay-setup',
              breadcrumbs: false
            },
            {
              id: 'salary-increments',
              title: 'Upload Salary increments',
              type: 'item',
              url: '/leave/employee-pay-setup',
              breadcrumbs: false
            },
            {
              id: 'employee-loans',
              title: 'Employee Loans',
              type: 'item',
              url: '/leave/employee-pay-setup',
              breadcrumbs: false
            }
          ]
        },
        {
          id: 'payroll-inputs',
          title: 'Payroll Inputs',
          type: 'collapse',
          icon: 'feather icon-check-square',
          classes: 'nav-item',
          children: [
            {
              id: 'earnings-deductions',
              title: 'Monthly Earnings/Deductions',
              type: 'item',
              url: 'layout/vertical/nav-fixed',
              breadcrumbs: false
            },
            {
              id: 'ratewise-inputs',
              title: 'Ratewise Inputs',
              type: 'item',
              url: '/customers/customer-list',
              breadcrumbs: false
            }
          ]
        },
        {
          id: 'payroll-processing',
          title: 'Payroll Processing',
          type: 'collapse',
          icon: 'feather icon-lock',
          classes: 'nav-item',
          children: [
            {
              id: 'monthly-payroll-processing',
              title: 'Monthly Payroll Processing',
              type: 'item',
              url: '/leave/monthly-payroll-processing',
              breadcrumbs: false
            },
            {
              id: 'monthly-supplementary-payroll',
              title: 'Monthly Supplementary Payroll',
              type: 'item',
              url: 'layout/vertical/nav-fixed',
              breadcrumbs: false
            },
            {
              id: 'payroll-increment-process',
              title: 'Payroll Increment Process',
              type: 'item',
              url: 'layout/vertical/nav-fixed',
              breadcrumbs: false
            }
          ]
        }
      ]
    },
    {
      id: '5',
      title: 'HR SELF SERVICE',
      type: 'group',
      icon: 'icon-support',
      children: [
        {
          id: '1',
          title: 'Leave Dashboard',
          type: 'item',
          icon: 'feather icon-sidebar',
          url: '/leave/leave-dash',
          classes: 'nav-item',
          breadcrumbs: false
        },
        {
          id: '2',
          title: 'Departmental Admin',
          type: 'item',
          url: '/leave/departmental-admin',
          classes: 'nav-item',
          icon: 'feather icon-file-text',
          breadcrumbs: false
        },
        {
          id: '3',
          title: 'Appraisals',
          type: 'item',
          url: '/sample-page',
          classes: 'nav-item',
          icon: 'icon-monitor'
        },
        {
          id: '4',
          title: 'Store Requisitions',
          type: 'item',
          url: '/store',
          classes: 'nav-item',
          icon: 'feather icon-package'
        },
        {
          id: '5',
          title: 'Help Desk',
          type: 'item',
          url: '/help-desk',
          classes: 'nav-item',
          icon: 'feather icon-help-circle'
        }
      ]
    }
  ]
};

export default menuItems;
